<script setup lang="ts">
defineProps<{
  styleInputOptions?: string;
}>();
</script>

<template>
  <div
    class="shadow-[0_2px_10px_rgba(0,0,0,0.3)] w-full bg-white p-6 mb-5 rounded-lg"
  >
    <h1 class="text-[#333] text-[22px] font-semibold mb-5">
      {{ $t("common.filter.filter") }}
    </h1>

    <div class="grid grid-cols-1 gap-4 mb-5" :class="styleInputOptions">
      <slot name="inputOptions"></slot>
      <div class="flex flex-col gap-1 col-span-1 md:col-span-1 lg:col-span-2">
        <label
          v-if="$slots.filterStateOptions"
          class="font-semibold text-gray-800 text-sm"
          >{{ $t("common.state") }}</label
        >
        <div class="flex flex-wrap gap-x-4 gap-y-2">
          <slot name="filterStateOptions"></slot>
        </div>
      </div>
    </div>
    <slot name="filterButtons"></slot>
  </div>
  <slot name="filterTagBox"></slot>
</template>
